import { useQuery } from "@tanstack/react-query";
import { CommonAPI } from "../types";
import { eventStreamQueries } from "../queries";

import { CardGrid } from "@bagel-web/components";
import ShowFunctions from "../session/ShowFunctions";
import { Spinner } from "react-bootstrap";
import { AgencyTagFilter } from "../tag/AgencyTagFilter";

const AgentMomentFunctions = ({
  sessionId,
  agentId,
  momentId,
  commonAPI,
  agencyTagFilter,
}: {
  sessionId: string;
  agentId: string;
  momentId: number;
  commonAPI: CommonAPI;
  agencyTagFilter: AgencyTagFilter;
}) => {
  const { isPending, data: eventStreamDetail } = useQuery({
    queryKey: eventStreamQueries.getDetail(sessionId, agentId, momentId),
    queryFn: () =>
      commonAPI.fetchEventStreamDetail(sessionId, agentId, momentId),
    staleTime: Infinity,
  });

  return (
    <div>
      {isPending && <Spinner className="mt-3" />}
      {eventStreamDetail?.functions &&
        eventStreamDetail.functions.length === 0 && (
          <p>No Agent Functions available for this Moment.</p>
        )}
      {eventStreamDetail?.functions &&
        eventStreamDetail.functions.length > 0 && (
          <CardGrid maxColumns={1}>
            <ShowFunctions
              functions={eventStreamDetail.functions}
              asCards={true}
              agencyTagFilter={agencyTagFilter}
            />
          </CardGrid>
        )}
    </div>
  );
};

export default AgentMomentFunctions;
